import adultWarningFormService from "../general/AdultWarningFormService";
import subheaderPromoBannerService from "../services/SubheaderPromoBannerService";
import shareButtonsService from "../services/ShareButtonsService";
import EshopConfiguration from "../services/EshopConfiguration";
import { Currency } from "../../../js/common/CurrencyFormatter";
import ProductListPageTypeConfig from "./ProductListPageTypeConfig";
import emptyCategoryProductListService from "./EmptyCategoryProductListService";
import SearchResultsListHeaderService from "./SearchResultsListHeaderService";
import CategoryListHeaderService from "./CategoryListHeaderService";
import ProductListContentContainer from "./ProductListContentContainer";
import packageCategoryWatchdogFormService from "./watchdog/PackageCategoryWatchdogFormService";

export default class ProductListPageService {
    private readonly productListContentContainer: ProductListContentContainer;

    constructor(
        eshopConfiguration: EshopConfiguration,
        private readonly pageTypeConfig: ProductListPageTypeConfig,
    ) {
        this.productListContentContainer = new ProductListContentContainer(pageTypeConfig);
    }

    public init(currency: Currency): void {
        packageCategoryWatchdogFormService.init(this.pageTypeConfig);

        if (this.pageTypeConfig.isAdult) {
            this.initAdultWarningForm();
        }

        if (this.pageTypeConfig.listType === "category") {
            this.initCategoryListServices();
        } else {
            this.initSearchListServices();
        }

        this.productListContentContainer.init(this.pageTypeConfig, currency);
        subheaderPromoBannerService.init();
        shareButtonsService.init();
    }

    private initAdultWarningForm(): void {
        adultWarningFormService.init();
    }

    private initCategoryListServices(): void {
        const categoryListHeaderService = new CategoryListHeaderService();

        categoryListHeaderService.init();

        if (this.pageTypeConfig.totalItems === 0) {
            emptyCategoryProductListService.init();
        }
    }

    private initSearchListServices(): void {
        const searchResultsListHeaderService = new SearchResultsListHeaderService();

        searchResultsListHeaderService.init();
    }
}
